/******* jQUERY FUNCTIONS BEGIN HERE *******/
$(function() {

/******* GLOBAL STUFF *******/

	// Detect OS & add a class to the HTML element, enabling PC ProximaNova-Light fix for Windows users.
	var $html = $('html');
	$html.addClass( navigator.platform ).removeClass('no-js');

	// make structure play nice with bootstrap dropdown navs
	function initDropdown() {
		var $width = document.documentElement.clientWidth;
		if ($width <= 479) {
			//disable main dropdpwn menu on small screen devices
			$('#main-navbar ul.navbar-nav li:has(ul)').find('> ul').addClass('hidden');
		}
		else if ($width >= 480) {
			//add dropdown class if li contains ul and data-toggle to link
			$('#main-navbar ul.navbar-nav li:has(ul)').find('> ul').removeClass('hidden');
			$('#main-navbar ul.navbar-nav li:has(ul)').addClass('dropdown').find('> a').addClass('dropdown-toggle disabled').attr('data-toggle', 'dropdown');
			//add dropdown-menu to nested ul
			$('#main-navbar ul.navbar-nav li > ul').addClass('dropdown-menu').css('display', '');
			$('#main-navbar ul.navbar-nav li:nth-last-child(-n+3) > ul').addClass('dropdown-menu-right');
			$('#main-navbar ul.nav li.dropdown').hover(function() {
				$(this).toggleClass('dropdown-active').find('.dropdown-menu').delay(100).fadeIn(300);
			}, function() {
				$(this).toggleClass('dropdown-active').find('.dropdown-menu').fadeOut(50);
			});
		}
	};
	initDropdown();
	$(window).smartresize(function(){
		initDropdown();
	});

	// Search field behaviors
	var searchForm		= 'form#sitesearch';
	var searchTrigger = $('#search-trigger');
	var searchfield		= $(searchForm + ' input[type="text"]');
	var submitButton	= $(searchForm + ' button[type="submit"]');

	// Placeholder text fallback
	if(!Modernizr.input.placeholder){
		$('[placeholder]').keydown(function() {
			var input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
				input.removeClass('placeholder');
			}
		}).blur(function() {
			var input = $(this);
			if (input.val() == '' || input.val() == input.attr('placeholder')) {
				input.addClass('placeholder');
				input.val(input.attr('placeholder'));
			}
		}).blur();
		$('[placeholder]').parents('form').submit(function() {
			$(this).find('[placeholder]').each(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
				}
			})
		});
	};

	// Trigger search field
	if(!Modernizr.input.placeholder){
		// Older Browsers
		searchTrigger.on('click',function(e){
			e.preventDefault();
			$(this).toggleClass('active');
			$(searchForm).slideToggle('600','easeOutBack');
			// We're not focusing on the search input because IE will not show the fallback placeholder text if the field has initial focus.
			searchfield.focus().val('').blur();
			submitButton.prop('disabled',true);
		});
	}
	else {
		searchTrigger.on('click',function(e){
			// Newer browsers
			e.preventDefault();
			$(this).toggleClass('active');
			$(searchForm).slideToggle('600','easeOutBack');
			searchfield.focus().val('');
			submitButton.prop('disabled',true);
		});
	}

	// disable submit button by default
	submitButton.prop('disabled',true);

	// enable submit button if search input is populated; disable if empty
	searchfield.keyup(function() {
		if($(this).val() != '') {
		  submitButton.prop('disabled',false);
		}
		else {
		  submitButton.prop('disabled',true);
		}
	});

	// Hide Search field if visible on scroll down.
	(function () {
		var previousScroll = 0;
		$(window).scroll(function () {
			if ($(window).width() > 767) {
				var currentScroll = $(this).scrollTop();
				if (currentScroll > previousScroll){
					$(searchForm).slideUp('slow');
					searchTrigger.removeClass('active');
					searchfield.val('');
					submitButton.prop('disabled',true);
				}
				previousScroll = currentScroll;
			}
		});
	}());

	// links - on state
	$('a').each(function(){
		if ($(this).attr('href') == (window.location.href) || $(this).attr('href') == (window.location.pathname)){
			$(this).addClass('here');
			$(this).parent().addClass('here')
		}
	});

	// Lazy Load Images
	var lazyImg = $('.lazy, .lazy2')

	lazyImg.show().lazyload({
		effect:'fadeIn',
		threshold:100,
		failure_limit:13
	});

	// Data tables
	$('#classlist').DataTable({
		'paging': 0,
		//'ordering':	0,
		'info': 0
	});
	$('#whodoeswhat').DataTable({
		//responsive: true,
 		"order": [[ 0, "asc" ]],
		"columns": [
			{ "width": "15%" },
	    { "width": "35%" },
	    { "width": "40%" },
			{ "width": "10%" }
	  ],
		'paging': 0,
		//'ordering':	0,
		'info': 0
	});

	// Smooth scroll anchor links
	$.extend( $.easing, {
		easeInOutExpo: function (x, t, b, c, d) {
			if (t==0) return b;
			if (t==d) return b+c;
			if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
			return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
		}
	});

	$('#alpha-nav a[href*=#], .page-nav a[href*=#], .backtotop a[href*=#]').on('click',function(e) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
			if ($target.length) {
				var targetOffset = $target.offset().top;
				$('html,body').animate({scrollTop: targetOffset}, 950, 'easeInOutExpo');
				return false;
			}
		}
	});


/******* LANDING PAGES *******/
//	if (	$('body#ID').length ||
//				$('body#ID').length ){
//
//	};

/******* SEARCH RESULTS PAGE *******/
	if ($('body#search').length){
		// Search field behaviors
		var searchfield2 = $('form#searchform input[type="text"]');
		var submitbutton2 = $('form#searchform button');

		// disable submit button by default
		submitbutton2.prop('disabled',true);

		// enable submit button if search input is populated; disable if empty
		searchfield2.keyup(function(){
			if($(this).val() != ''){
				submitbutton2.prop('disabled',false);
			}
			else {
				submitbutton2.prop('disabled',true);
			}
		});
	};

});
